export default __webpack_public_path__ + "static/media/contact-us-bg.ed7846be.webp";